import { axiosInstance } from "./axiosInstance";


export const SubMateriService = {
    getAll: async (filter) => {
        return await axiosInstance.get('/api/feature/membership/materi/submateri', { params: filter });
    },
    create: async (data) => {
        return await axiosInstance.post('/api/feature/membership/materi/submateri', data);
    },
    update: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/materi/submateri/update/${id}`, data);
    },
    delete: async (id) => {
        return await axiosInstance.delete(`/api/feature/membership/materi/submateri/delete/${id}`);
    },
    attachDetach: async (method, type, idSubmateri, idTryout) => {
        return await axiosInstance.post(`/api/feature/membership/materi/submateri/attach-detach/${method}/${type}/${idSubmateri}/${idTryout}`);
    },
    replicate: async (id) => {
        return await axiosInstance.post(`/api/feature/membership/materi/submateri/replicate/${id}`);
    }
}